import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { toast } from '../hooks/use-toast';
import { Lock, User } from 'lucide-react';

const StaffLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'password' && value.length > 6) return;
    if (name === 'password' && value && !/^\d*$/.test(value)) return;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { login } = await import('../api/api');
      const data = await login(formData.username, formData.password);
      localStorage.setItem('staffToken', data.access_token);
      localStorage.setItem('staffUsername', data.user.username);
      localStorage.setItem('staffName', data.user.name);
      localStorage.setItem('staffRole', data.user.role);
      toast({ title: 'Connexion reussie', description: `Bienvenue ${data.user.name} !` });
      navigate('/staff/dashboard');
    } catch (error) {
      toast({ title: 'Erreur de connexion', description: error.response?.data?.detail || 'Identifiant ou code incorrect', variant: 'destructive' });
    } finally { setLoading(false); }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center py-12 px-4"
      style={{ backgroundImage: 'url(/images/restaurant/01-fullsizerender1-1040.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      <Card className="w-full max-w-md relative z-10 border-2 border-gray-300" data-testid="login-card">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-4">
            <img src="/logo-taverne.png" alt="La Taverne" className="h-24 mx-auto" />
          </div>
          <CardTitle className="text-2xl font-bold text-[#2c1810]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Espace Staff
          </CardTitle>
          <p className="text-gray-600 mt-2">Connectez-vous avec votre identifiant</p>
        </CardHeader>
        <CardContent className="pt-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-gray-700 font-semibold">Nom d'utilisateur</Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <Input
                  id="username" name="username" type="text"
                  placeholder="votre identifiant"
                  value={formData.username} onChange={handleChange}
                  className="pl-10 border-2 border-gray-300 focus:border-red-500"
                  required data-testid="login-username"
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-gray-700 font-semibold">Code (6 chiffres)</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                <Input
                  id="password" name="password" type="password"
                  placeholder="000000" inputMode="numeric" maxLength={6}
                  value={formData.password} onChange={handleChange}
                  className="pl-10 border-2 border-gray-300 focus:border-red-500 tracking-[0.3em] text-center text-lg"
                  required data-testid="login-password"
                />
              </div>
            </div>
            <Button type="submit" disabled={loading || formData.password.length !== 6}
              className="w-full bg-red-600 hover:bg-red-700 text-white py-6 text-lg font-bold transition-all duration-300"
              data-testid="login-submit-btn">
              {loading ? 'Connexion...' : 'SE CONNECTER'}
            </Button>
          </form>
          <div className="mt-6 text-center">
            <button onClick={() => navigate('/')} className="text-sm text-gray-600 hover:text-gray-800 underline">
              Retour a l'accueil
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StaffLogin;
